const PRIMARY = "#1CA069";
const BORDER = "#dfe8e6";

function Spinner({ size = 32 }) {
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        border: `3px solid ${BORDER}`,
        borderTopColor: PRIMARY,
        animation: "coco-spin 0.8s linear infinite",
      }}
    >
      <style>{`@keyframes coco-spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}

export default Spinner;